<script setup lang="ts">
import { __ } from '@@/bits/intl'
import type { SearchFilters } from '@@/bits/web_search'
import OzDivider, { OzDividerColorScheme } from '@@/library/v4/components/OzDivider.vue'
import OzTabs, { OzTabsPlacementMode } from '@@/library/v4/components/OzTabs.vue'
import { type ContentPickerSearchMode } from '@@/pinia/content_picker'
import { computed, ref } from 'vue'

const props = defineProps<{
  searchModes: ContentPickerSearchMode[]
  currentSearchFilter: SearchFilters
}>()

const emit = defineEmits<{
  (name: 'filter-selected', filter: string): void
}>()

const displayedSearchModes = computed(() => props.searchModes.filter((mode) => mode.visible))

const isShook = ref<boolean>(false)

const shake = (): void => {
  isShook.value = false
  setTimeout(() => {
    isShook.value = true
  }, 1)
}

defineExpose({
  shake,
})
</script>

<template>
  <div class="flex shrink-0 flex-col mx-4">
    <div :class="['mx-4', 'md:mx-6', 'mt-1', 'md:mt-0', isShook && 'animate-shake']">
      <OzTabs
        data-testid="contentPickerSearchModes"
        :placement-mode="OzTabsPlacementMode.Stretch"
        :aria-label="__('Content search tabs')"
        :tabs="displayedSearchModes"
        :current-tab-key="currentSearchFilter"
        @activate-tab="(_event, payload) => emit('filter-selected', payload.key)"
      />
    </div>
    <OzDivider :color-scheme="OzDividerColorScheme.Solid" />
  </div>
</template>
